export default {
  USER_EXTEND_LOGIN(state, duration) {
    const expiration = Date.now() + duration * 1000;
    state.login_until = expiration;
    localStorage.setItem('login_until', expiration);
  },
  USER_LOGIN(state, user, duration) {
    state.login = true;
    localStorage.setItem('login', true);
    state.user = user;
    let dur = 7200;
    if(duration){ dur = duration }
    const expiration = Date.now() + dur * 1000;
    state.login_until = expiration;
  },
  USER_LOGOUT(state) {
    state.login = false;
    state.login_until = Date.now() - 1;
    state.user = null;
    state.jwt_token = null;
    localStorage.setItem('login_until', state.login_until);
    localStorage.removeItem('login');
  },
  USER_SET_JWTTOKEN(state, token) {
    state.jwt_token = token;
  },
  DISPLAY_ERROR(state, text) {
    state.snackbar = {
      open: true,
      text,
      color: 'error',
      timeout: 6000,
    };
  },
  DISPLAY_SUCCESS(state, text) {
    state.snackbar = {
      open: true,
      text,
      color: 'success',
      timeout: 6000,
    };
  },
};
